import React, { createContext, useContext, useMemo } from 'react'

import { LinkProps } from '@unlikelystudio/react-abstract-components'

export const BreadcrumbContext = createContext<BreadcrumbContent>({})

export function useBreadCrumb() {
  return useContext(BreadcrumbContext)
}

export type BreadcrumbContent = {
  links?: LinkProps[]
}

export type BreadcrumbProviderProps = BreadcrumbContent & {
  children?: JSX.Element | JSX.Element[]
}

export default function BreadCrumbProvider({
  children,
  links,
}: BreadcrumbProviderProps) {
  const memoized = useMemo(
    () => ({
      links,
    }),
    [links],
  )

  return (
    <BreadcrumbContext.Provider value={memoized}>
      {children}
    </BreadcrumbContext.Provider>
  )
}
